<template>
  <div :class="[!$auth.isAuthenticated.value ? 'h-screen overflow-hidden' : '']">
    <navbar></navbar>
    <div>
      <div v-if="loading || $auth.loading.value">
        <div class="relative text-center mx-auto my-4" style="max-width: 300px;">
          <p class="mb-1 uppercase tracking-widest font-light font-sm opacity-70">Loading Results</p>
        </div>
      </div>
      <dashboard v-else></dashboard>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar"
import Dashboard from "./views/Dashboard"
import { mapGetters, mapActions } from "vuex"

export default {
  components: {
    Dashboard,
    Navbar
  },
  computed: {
    ...mapGetters({
      cities: "geojson/cities",
      constituencies: "geojson/constituencies",
      states: "geojson/states"
    })
  },
  methods: {
    ...mapActions({
      getCities: "geojson/getCities",
      getConstituencies: "geojson/getConstituencies",
      getStates: "geojson/getStates"
    })
  },
  data: () => ({
    loading: false
  }),
  async beforeMount() {
    this.loading = true;

    // for (var key in localStorage) {
    //   if (key.includes("k_elections") && key !== storageKey) {
    //     localStorage.removeItem(key);
    //   }
    // }

    const promises = [];

    if (this.cities.length === 0) {
      promises.push(this.getCities());
    }

    if (this.constituencies.length === 0) {
      promises.push(this.getConstituencies());
    }

    if (this.states.length === 0) {
      promises.push(this.getStates());
    }

    const token = this.$auth.token.value
    if (token) {
      promises.push(this.$auth.authenticate(token))
    }

    const hash = window.location.hash
    if (hash.startsWith('#access_token')) {
      const RE = /access_token=(.[^&]*)&/
      const token = hash.match(RE)[1]
      window.location.href = window.location.origin
      await this.$auth.login(token)
    }

    Promise.all(promises).then(() => {
      this.loading = false;
    });
  }
};
</script>

<style>
:root {
  --border-color: rgba(255, 255, 255, 0.12);
}

.container {
  max-width: 800px !important;
  padding: 0 15px;
  margin: 0 auto;
}
</style>
